<div style="height:600px;">
  <json-editor
    (change)="changeLog($event)"
    [options]="editorOptions" 
    [data]="configData"
    #editor
  ></json-editor> 
  <button (click)="submitJsonForm($event)"
    class="dhl-button-v2 buttons-primary">Update</button>
</div>
